import { useEffect, useState } from "react";

const categories = [
  "Bracelets",
  "Earrings",
  "Necklaces",
  "Rings",
  "Mens",
  "Under $1,000",
  "Shop All Categories",
];

const designers = [
  "Sofia Collection by Lucas & Carl Priolo",
  "Alex Sepkus",
  "Campbell + Charlotte",
  "Chris Ploof",
  "Dilamani",
  "DSL",
  "Imperfect Grace",
  "Marco Dal Maso",
  "Moritz Glik",
  "Rare Colors",
  "Suzanne Kalan",
  "Suneera",
  "Sethi Couture",
  "Todd Reed",
  "Shop All Designers",
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState<string | null>("SHOP");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = drawerOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [drawerOpen]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Left nav (desktop) */}
          <nav className="hidden md:flex items-center gap-8 flex-1">
            <div className="group relative">
              <a
                href="#featured"
                className="font-label text-xs tracking-[0.22em] uppercase text-foreground-900 hover:text-primary-600 transition-colors inline-flex items-center gap-1 py-3"
              >
                Shop
                <i className="ri-arrow-down-s-line text-sm" />
              </a>
              {/* Mega menu */}
              <div className="invisible opacity-0 translate-y-2 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 absolute left-0 top-full w-[720px] bg-background-50 border border-background-200 p-8 grid grid-cols-3 gap-8">
                <div>
                  <p className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-500 mb-4">
                    By Category
                  </p>
                  <ul className="space-y-2.5">
                    {categories.map((c) => (
                      <li key={c}>
                        <a
                          href="#featured"
                          className="font-body text-sm text-foreground-800 hover:text-primary-600 transition-colors"
                        >
                          {c}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div>
                  <p className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-500 mb-4">
                    Designers
                  </p>
                  <ul className="space-y-2.5">
                    {designers.slice(0, 9).map((d) => (
                      <li key={d}>
                        <a
                          href="#featured"
                          className="font-body text-sm text-foreground-800 hover:text-primary-600 transition-colors"
                        >
                          {d}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="space-y-5">
                  <a href="#featured" className="block group/push">
                    <div className="w-full h-28 overflow-hidden bg-secondary-100">
                      <img
                        src="https://sofiajewelry.com/cdn/shop/files/AP70126D-211H-2_370x230@2x.jpg?v=1775066846"
                        alt="Pick of the month black rhodium diamond dog tag"
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover/push:scale-105"
                      />
                    </div>
                    <p className="font-label text-[11px] tracking-[0.2em] uppercase mt-2 text-foreground-900">
                      Pick of the Month
                    </p>
                    <p className="font-body text-[11px] text-foreground-500 uppercase tracking-wide">
                      Black Rhodium Diamond Dog Tag
                    </p>
                  </a>
                  <a href="#featured" className="block group/push">
                    <div className="w-full h-28 overflow-hidden bg-secondary-100">
                      <img
                        src="https://sofiajewelry.com/cdn/shop/files/FND-22-R14-WD_1_370x230@2x.jpg?v=1761599115"
                        alt="Designer of the month Campbell and Charlotte"
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover/push:scale-105"
                      />
                    </div>
                    <p className="font-label text-[11px] tracking-[0.2em] uppercase mt-2 text-foreground-900">
                      Designer of the Month
                    </p>
                    <p className="font-body text-[11px] text-foreground-500 uppercase tracking-wide">
                      Campbell + Charlotte
                    </p>
                  </a>
                </div>
              </div>
            </div>

            <div className="group relative">
              <a
                href="#custom"
                className="font-label text-xs tracking-[0.22em] uppercase text-foreground-900 hover:text-primary-600 transition-colors inline-flex items-center gap-1 py-3"
              >
                Custom
                <i className="ri-arrow-down-s-line text-sm" />
              </a>
              <div className="invisible opacity-0 translate-y-2 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 absolute left-0 top-full w-56 bg-background-50 border border-background-200 p-6 space-y-3">
                <a href="#custom" className="block font-body text-sm text-foreground-800 hover:text-primary-600">
                  Custom Creations
                </a>
                <a href="#looks" className="block font-body text-sm text-foreground-800 hover:text-primary-600">
                  Gallery
                </a>
                <a href="#contact" className="block font-body text-sm text-foreground-800 hover:text-primary-600">
                  Make an Appointment
                </a>
              </div>
            </div>

            <div className="group relative">
              <a
                href="#story"
                className="font-label text-xs tracking-[0.22em] uppercase text-foreground-900 hover:text-primary-600 transition-colors inline-flex items-center gap-1 py-3"
              >
                About
                <i className="ri-arrow-down-s-line text-sm" />
              </a>
              <div className="invisible opacity-0 translate-y-2 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200 absolute left-0 top-full w-56 bg-background-50 border border-background-200 p-6 space-y-3">
                <a href="#story" className="block font-body text-sm text-foreground-800 hover:text-primary-600">
                  The Priolo Family
                </a>
                <a href="#story" className="block font-body text-sm text-foreground-800 hover:text-primary-600">
                  Meet the Team
                </a>
              </div>
            </div>
          </nav>

          {/* Mobile hamburger */}
          <button
            type="button"
            aria-label="Open navigation"
            onClick={() => setDrawerOpen(true)}
            className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-900 cursor-pointer"
          >
            <i className="ri-menu-line text-2xl" />
          </button>

          {/* Logo */}
          <a href="/" className="flex items-center justify-center">
            <img
              src="https://sofiajewelry.com/cdn/shop/files/88_210x.jpg?v=1668034085"
              alt="Sofia Jewelry"
              className="h-8 md:h-10 w-auto object-contain"
            />
          </a>

          {/* Right nav */}
          <div className="flex items-center justify-end gap-5 flex-1">
            <button
              type="button"
              aria-label="Search"
              className="hidden md:flex w-8 h-8 items-center justify-center text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-search-line text-lg" />
            </button>
            <a
              href="#contact"
              className="hidden md:inline font-label text-xs tracking-[0.22em] uppercase text-foreground-700 hover:text-primary-600 transition-colors"
            >
              Account
            </a>
            <a
              href="#featured"
              className="inline-flex items-center gap-1.5 font-label text-xs tracking-[0.22em] uppercase text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer"
            >
              Cart
              <span className="text-foreground-500">(0)</span>
            </a>
          </div>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`md:hidden fixed inset-0 z-[60] transition-opacity duration-300 ${
          drawerOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-foreground-950/40"
          onClick={() => setDrawerOpen(false)}
        />
        <div
          className={`absolute left-0 top-0 h-full w-[82%] max-w-sm bg-background-50 overflow-y-auto transition-transform duration-300 ${
            drawerOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div className="flex items-center justify-between px-5 h-16 border-b border-background-200">
            <img
              src="https://sofiajewelry.com/cdn/shop/files/88_210x.jpg?v=1668034085"
              alt="Sofia Jewelry"
              className="h-7 w-auto object-contain"
            />
            <button
              type="button"
              aria-label="Close navigation"
              onClick={() => setDrawerOpen(false)}
              className="w-9 h-9 flex items-center justify-center text-foreground-900 cursor-pointer"
            >
              <i className="ri-close-line text-2xl" />
            </button>
          </div>

          <nav className="px-5 py-6">
            {[
              {
                key: "SHOP",
                items: [...categories.slice(0, 6), "Shop All Categories"],
              },
              { key: "CUSTOM", items: ["Custom Creations", "Gallery", "Make an Appointment"] },
              { key: "ABOUT", items: ["The Priolo Family", "Meet the Team"] },
            ].map((group) => (
              <div key={group.key} className="border-b border-background-200">
                <button
                  type="button"
                  onClick={() =>
                    setOpenGroup(openGroup === group.key ? null : group.key)
                  }
                  className="w-full flex items-center justify-between py-4 cursor-pointer"
                >
                  <span className="font-label text-sm tracking-[0.2em] uppercase text-foreground-900">
                    {group.key}
                  </span>
                  <i
                    className={`ri-add-line text-xl text-foreground-500 transition-transform ${
                      openGroup === group.key ? "rotate-45" : ""
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openGroup === group.key ? "max-h-96 pb-4" : "max-h-0"
                  }`}
                >
                  <ul className="space-y-3">
                    {group.items.map((item) => (
                      <li key={item}>
                        <a
                          href="#featured"
                          onClick={() => setDrawerOpen(false)}
                          className="block font-body text-sm text-foreground-600"
                        >
                          {item}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}

            <div className="pt-6 space-y-3">
              <a href="#contact" className="block font-body text-sm text-foreground-700">
                Contact Us
              </a>
              <a href="#story" className="block font-body text-sm text-foreground-700">
                FAQs
              </a>
              <a href="#story" className="block font-body text-sm text-foreground-700">
                Shipping &amp; Return Policy
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}